import { apiDelete, apiGet, apiPost, apiPut } from './client';
import type {
  CreateVenteRequest,
  LeaderboardAgenceDto,
  LeaderboardEntryDto,
  MeResponse,
  Metric,
  PalmaresEntryDto,
  PalmaresMonthDetailDto,
  PalmaresMonthDto,
  Period,
  Scope,
  TodayActivityDto,
  UpdateMeRequest,
  UpdateVenteRequest,
  UserDto,
  VenteDto
} from './types';

// ─── Me ─────────────────────────────────────────────────────────
export const meApi = {
  get: () => apiGet<MeResponse>('/api/me'),
  update: (req: UpdateMeRequest) => apiPut<UserDto>('/api/me', req)
};

// ─── Ventes ─────────────────────────────────────────────────────
export const ventesApi = {
  list: (period: Period = 'month', search?: string) =>
    apiGet<VenteDto[]>('/api/ventes', { period, search: search ?? undefined }),

  get: (id: string) => apiGet<VenteDto>(`/api/ventes/${id}`),

  create: (req: CreateVenteRequest) => apiPost<VenteDto>('/api/ventes', req),

  update: (id: string, req: UpdateVenteRequest) =>
    apiPut<VenteDto>(`/api/ventes/${id}`, req),

  delete: (id: string) => apiDelete<void>(`/api/ventes/${id}`)
};

// ─── Leaderboard ────────────────────────────────────────────────
export const leaderboardApi = {
  individual: (metric: Metric = 'score', period: Period = 'month') =>
    apiGet<LeaderboardEntryDto[]>('/api/leaderboard', { metric, period, scope: 'ind' }),

  agence: (metric: Metric = 'score', period: Period = 'month') =>
    apiGet<LeaderboardAgenceDto[]>('/api/leaderboard', { metric, period, scope: 'agence' }),

  generic: (metric: Metric, period: Period, scope: Scope) =>
    apiGet<LeaderboardEntryDto[] | LeaderboardAgenceDto[]>(
      '/api/leaderboard', { metric, period, scope }
    ),

  palmares: (period: Period = 'month') =>
    apiGet<PalmaresEntryDto[]>('/api/leaderboard/palmares', { period }),

  /** Historique des mois passés (hors mois courant). */
  palmaresHistory: () =>
    apiGet<PalmaresMonthDto[]>('/api/leaderboard/palmares-history'),

  /** Détail d'un mois passé : top 10 ind + agences sur les 4 métriques. */
  palmaresMonth: (month: string) =>
    apiGet<PalmaresMonthDetailDto>(`/api/leaderboard/palmares-month/${month}`),

  today: () => apiGet<TodayActivityDto>('/api/leaderboard/today')
};
